<template>
  <div class="time-display">
    <div class="time">{{ formattedTime }}</div>
    <div class="date">{{ formattedDate }}</div>
  </div>
</template>

<script>

import SkyconComponent from 'vue-skycons';

export default {
  name: 'TimesView',
  components: {
    SkyconComponent
  },
  data() {
    return {
      // 时间数据
      currentDate: new Date()
    }
  },
  computed: {
    formattedDate() {
      const options = { year: 'numeric', month: 'long', day: 'numeric', weekday: 'long' };
      return this.currentDate.toLocaleDateString('zh-CN', options);
    },
    formattedTime() {
      return this.currentDate.toLocaleTimeString('zh-CN', { hour12: false });
    },
  },
  mounted() {
    this.updateTime();
    this.interval = setInterval(this.updateTime, 1000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    updateTime() {
      this.currentDate = new Date();
    }
  },
};
</script>

<style scoped>
.time-display {
  text-align: center;
  border-radius: 10px;
  padding: 10px;
  font-family: "Playfair Display", serif;
}

.date {
  font-size: 16px;
}

.time {
  font-size: 50px;
  font-weight: bold;
}
</style>